/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getApprovalLevelDetails } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export function useGetApprovalLevelDetails(id: number, options?: UseQueryOptions) {
  return useQuery({
    queryKey: userQueryKeys.approvalLevelDetails(id),
    queryFn: () => getApprovalLevelDetails(id).then((res) => res.data),
    ...options,
  });
}
